import { useEffect } from 'react'

// Redux.
import { connect } from 'react-redux';

// Firebase.
import { auth } from '../firebaseHelper';
import { useAuthState } from 'react-firebase-hooks/auth';

// Components.
import MyNotesContent from '../components/MyNotesContent';
import SigninRequired from '../components/SigninRequired';

const MyNotes = ({
    authenticated,
}) => {

    const [user, userLoading, error] = useAuthState(auth);

    const safeAreaBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sab"));
    useEffect(() => {
        const audio = document.getElementById('audio');
        audio.pause();
    }, [])

    if (authenticated !== true) {
        return <SigninRequired authenticated={authenticated} />;
    }

    return (
        <div className="container appScreen">
            <div className='main'>
                {userLoading ?
                    <div>
                        <div className='center'>
                            <div style={{ paddingBottom: `${safeAreaBottom + 20}px` }}>
                                <img className='glow icon' src='/icon.png' />
                            </div>
                        </div>
                    </div>
                    :
                    <MyNotesContent />
                }
            </div>
        </div >
    )
}

MyNotes.propTypes = {

}

MyNotes.defaultProps = {
}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(MyNotes);
